export enum IrpSortField {
    CreatedDate,
    UpdatedDate,
    NumberIrp,
    Object,
    ProcessNumber,
    Year,
    Sequence,
    Modality,
    ManagingUnit,
    ClientName
}
